export enum LoginEvent {
  LOGIN_INIT = "LoginInitiatedEvent",
  LOGIN_SUCCESS = "LoginSuccessEvent",
  LOGIN_FAILURE = "LoginFailureEvent",
}
